module.exports = __webpack_public_path__ + "static/assets/e03a57a998de396f7a89ac47d0214769.png";